import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IsNotCalibratedReasonService } from 'src/app/core/services/is-not-calibrated-reason.service';

@Component({
    standalone: false,
    selector: 'app-calibration-admin-page',
    templateUrl: './calibration-admin-page.component.html',
    styleUrls: ['./calibration-admin-page.component.scss']

})
export class CalibrationAdminPageComponent implements OnInit {
    @HostBinding('class')
    hostClass = 'admin';

    constructor(private readonly router: Router, private isNotCalibratedReasonService: IsNotCalibratedReasonService) {
        this.isNotCalibratedReasonService.getAll().subscribe();
    }

    ngOnInit(): void {}

    isOpened(path: string): boolean {
        return this.router.url === `/admin/${path}`;
    }
}
